import type { FiscalRow, FiscalSource } from "@/types";

export const METHOD_LABEL: Record<FiscalRow["method"], string> = {
  monri: "Kartica",
  bank_transfer: "Uplata na račun",
  manual: "Ručno",
  invoice: "Faktura",
};

export const FLAG_LABEL: Record<NonNullable<FiscalRow["flag"]>, string> = {
  refunded: "Povrat",
  void: "Stornirano",
};

/** Nazivi vrsta u zbiru dana. */
export const SOURCE_TOTAL_LABEL: Record<FiscalSource, string> = {
  session: "Seanse",
  enrollment: "Grupe",
  subscription: "Pretplate",
  company_invoice: "Firme",
};

export type SourceFilter = "all" | FiscalSource;

export const SOURCE_FILTER_OPTIONS: { value: SourceFilter; label: string }[] = [
  { value: "all", label: "Sve" },
  { value: "session", label: "Seanse" },
  { value: "enrollment", label: "Grupe" },
  { value: "subscription", label: "Pretplate" },
  { value: "company_invoice", label: "Firme" },
];

export function hasConfirmation(row: Pick<FiscalRow, "source">): boolean {
  return row.source === "session" || row.source === "enrollment";
}

/** Potvrda se očekuje (ima snapshot, nastala poslije puštanja praćenja), a nije poslana. */
export function isConfirmationMissing(
  row: Pick<FiscalRow, "source" | "base" | "at" | "confirmationSentAt">,
  trackingStart: string | null,
): boolean {
  return (
    hasConfirmation(row) &&
    row.base !== null &&
    row.confirmationSentAt === null &&
    trackingStart !== null &&
    row.at >= trackingStart
  );
}

export function rowKey(row: Pick<FiscalRow, "source" | "sourceId">): string {
  return `${row.source}:${row.sourceId}`;
}

export function confirmationPdfUrl(row: Pick<FiscalRow, "source" | "sourceId">): string {
  return `/api/admin/fiscalization/confirmation/${row.source}/${encodeURIComponent(row.sourceId)}`;
}

/** Dodaje (ili oduzima) kalendarske dane na `YYYY-MM-DD` bez UTC pomaka. */
export function shiftYmd(ymd: string, days: number): string {
  const [y = 0, m = 1, d = 1] = ymd.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, d + days)).toISOString().slice(0, 10);
}
